import { useEffect } from "react";
import { useSpaceStore } from "../stores";

/**
 * Re-centers the view when device orientation changes.
 * Uses a short debounce to let the browser settle its new dimensions.
 */
export function useOrientationSync(): void {
	useEffect(() => {
		const mql = window.matchMedia("(orientation: portrait)");
		const handler = () => {
			setTimeout(() => {
				const state = useSpaceStore.getState();
				const key = state.viewMode === "galaxy" ? "galaxyView" : "systemView";
				const current = state[key];
				useSpaceStore.setState({
					[key]: {
						...current,
						offsetX: window.innerWidth / 2,
						offsetY: window.innerHeight / 2,
					},
				});
			}, 100);
		};
		mql.addEventListener("change", handler);
		return () => mql.removeEventListener("change", handler);
	}, []);
}
